import * as React from 'react';

const SpeechBubble24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m3.95 20.05.77-3.648-.25-.478A8.47 8.47 0 0 1 3.5 12c0-4.686 3.814-8.5 8.5-8.5s8.5 3.814 8.5 8.5-3.814 8.5-8.5 8.5a8.47 8.47 0 0 1-3.924-.97l-.478-.25-3.647.77Zm-.44 1.625 3.87-.816A9.97 9.97 0 0 0 12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12c0 1.606.393 3.191 1.141 4.62l-.816 3.87a1 1 0 0 0 1.185 1.185M15.25 12a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M12 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-4.5 2.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
    clipRule: "evenodd"
  }
));
SpeechBubble24.Size = 24;
SpeechBubble24.Title = "SpeechBubble";

export { SpeechBubble24 as default };
